export const TOPIC_CATEGORIES = [
  { id: "general", label: "Tổng hợp", emoji: "💬" },
  { id: "challenge", label: "Thử thách", emoji: "🎯" },
  { id: "motivation", label: "Động lực", emoji: "🔥" },
  { id: "question", label: "Hỏi đáp", emoji: "❓" },
  { id: "share", label: "Chia sẻ", emoji: "📝" },
];

export const CHAT_MESSAGE_LIMIT = 50;
export const TOPIC_PAGE_SIZE = 20;
